import InvoiceAdjustmentsTable from "@app/components/invoice/invoice-adjustments-table.tsx";
import InvoiceIncludedItemsTable from "@app/components/invoice/invoice-included-items-table.tsx";
import InvoicePotentialItemContainer from "@app/components/invoice/invoice-potential-items-container.tsx";
import Kvp from "@app/components/kvp.tsx";
import PageTitle from "@app/components/page-title.tsx";
import useInvoiceManagementData from "@app/data-hooks/use-invoice-management-data.ts";
import { formatDate } from "@app/helpers/time-helper.ts";
import { TabContext, TabList, TabPanel } from "@mui/lab";
import { Grid2, Stack, Tab } from "@mui/material";
import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { QueryStatusRouter } from "bi-lib";
import { useState } from "react";

interface SearchParams {
    tab1?: string;
    tab2?: string;
}

export const Route = createFileRoute("/_authenticated/_manager/invoice/$invoiceId/")({
    component: Component,
    validateSearch: (search: Record<string, unknown>): SearchParams => {
        return {
            tab1: search.tab1 as string | undefined,
            tab2: search.tab2 as string | undefined,
        };
    },
});

function Component() {
    const search = Route.useSearch();
    const [activeTab, setActiveTab] = useState(search.tab1 ?? "included");

    const invoiceId = +Route.useParams().invoiceId;

    const { invoice } = useInvoiceManagementData({ id: invoiceId });
    const navigate = useNavigate();

    const handleChangeTab = (tab: string) => {
        setActiveTab(tab);
        void navigate({ to: ".", search: { ...search, tab1: tab } });
    };

    return (
        <>
            <PageTitle>Invoice {invoice.data?.invoiceNumber != undefined && invoice.data.invoiceNumber}</PageTitle>
            <QueryStatusRouter queryHook={invoice}>
                <Grid2 container my={2}>
                    <Grid2 size={4}>
                        <Kvp keyTitle={"Invoice Number"}>{invoice.data?.invoiceNumber}</Kvp>
                        <Kvp keyTitle={"Start Date"}>{formatDate(invoice.data?.startDate)}</Kvp>
                    </Grid2>
                    <Grid2 size={4}>
                        <Kvp keyTitle={"Assignment Number"}>{invoice.data?.assignmentNumber}</Kvp>
                        <Kvp keyTitle={"End Date"}>{formatDate(invoice.data?.endDate)}</Kvp>
                    </Grid2>
                    <Grid2 size={4}>
                        <Kvp keyTitle={"Assignment Description"}>{invoice.data?.assignmentDescription}</Kvp>
                    </Grid2>
                </Grid2>
                <TabContext value={activeTab}>
                    <TabList onChange={(_, value) => handleChangeTab(value)}>
                        <Tab value={"included"} label={"Included Items"} />
                        <Tab value={"potential"} label={"Potential Items"} />
                        <Tab value={"adjustments"} label={"Adjustments"} />
                    </TabList>
                    <TabPanel value={"included"}>
                        <Stack spacing={2}>
                            <InvoiceIncludedItemsTable invoiceId={invoiceId} categoryId={1} title={"Time"} />
                            <InvoiceIncludedItemsTable invoiceId={invoiceId} categoryId={2} title={"Travel Expenses"} />
                            <InvoiceIncludedItemsTable
                                invoiceId={invoiceId}
                                categoryId={3}
                                title={"Other Individual Expenses"}
                            />
                            <InvoiceIncludedItemsTable invoiceId={invoiceId} categoryId={4} title={"Office Expenses"} />
                        </Stack>
                    </TabPanel>
                    <TabPanel value={"potential"}>
                        <InvoicePotentialItemContainer invoiceId={invoiceId} />
                    </TabPanel>
                    <TabPanel value={"adjustments"}>
                        <InvoiceAdjustmentsTable invoiceId={invoiceId} />
                    </TabPanel>
                </TabContext>
            </QueryStatusRouter>
        </>
    );
}
